import { endOfDay, startOfDay } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { DatePickerInput } from '@/components/ui/date-picker-input'
import { DateRange } from '@/models/helpers'

export interface CreatedDateRangeFilters {
  fromDate?: number
  toDate?: number
}

interface CreatedDateRangePickerProps extends CreatedDateRangeFilters {
  onChange: (filters: CreatedDateRangeFilters) => void
}

export const CreatedDateRangePicker = ({
  fromDate,
  onChange,
  toDate,
}: CreatedDateRangePickerProps) => {
  const { t } = useTranslation(['organisation'])

  const value: DateRange = [fromDate ? new Date(fromDate) : null, toDate ? new Date(toDate) : null]

  const handleRangeChange = ([from, to]: DateRange) => {
    onChange({
      fromDate: from ? startOfDay(from).getTime() : undefined,
      toDate: to ? endOfDay(to).getTime() : undefined,
    })
  }

  return (
    <DatePickerInput
      mode="range"
      placeholder={t('organisation:shared.dateRange.placeholder')}
      size="small"
      value={value}
      onRangeChange={handleRangeChange}
    />
  )
}
